export default __webpack_public_path__ + "97fbc9d5392a24af576ffc718aee2d70.png";